import React from "react";
import { get } from "lodash";
import Spinner from "~/components/Spinner";
import { setPlaySourcePrefix } from "~/tools/analytics/cleverTap";
import { ellipsifyByChar, ellipsifyByWord} from '~/tools/strings/ellipsify'
import _ from 'lodash'
import "./styles.css";

class ListItemTiles extends React.Component {


  handleClick = (e, i, season, item) => {
    const { trayTitle, isEpisode, openEpisodeOverlay } = this.props || {}
    const title = trayTitle ? trayTitle : "";
    setPlaySourcePrefix(title);
    if (isEpisode) {
      openEpisodeOverlay(e, i, season, item);
    }
  };

  renderItems = (item, i) => {
    const placeholderImg = _.get(window.settings, 'images.placeholderCover')
    const isEpisodePurchasable =
      !item.free &&
      (item.pricing && item.pricing.purchase !== null) &&
      item.purchaseStatus !== "PURCHASED" &&
      this.props.isEpisode;
    return (
      <div className="list__item__container" key={i}>
        <a
          href={`${item.permalink}?start=${item.watchedTime}`}
          className="list__item__title"
          onClick={e => this.handleClick(e, i, this.props.season, item.container)}
        >
            <figure className="image-container">
              <img src={`${item.videoImageUrl || item.posterImageUrl || (item.imageGist && item.imageGist['_16x9']) || placeholderImg}?imwidth=300`} />
              {item.contentType !== 'SERIES' && <i className="ion-ios-play site-color" />}
            </figure>
          <div className={`title-container ${isEpisodePurchasable ? 'purchasable' : ''}`}>
            <div className="title">
              { isEpisodePurchasable ? ellipsifyByChar(item.title, 25) : item.title }
            </div>
          </div>
        </a>
      </div>
    );
  };

  render() {
    const items = this.props.items 
    const titleColor = get(window.settings, "brand.general.blockTitleColor");

    return (
      items && (
        <div className="list__tiles">
          <div className="list__header">
            <div className="list__header__title" style={{ color: titleColor }}>
              {this.props.header}
            </div>
          </div>
          <div className="list__body">
            {items && (
              <div className="list__body__container">
                {items.map((item, i) =>(
                    this.renderItems(item, i)
                  )
                )}
              </div>  
            )}
          </div>
          {this.props.fetching && <Spinner />}
        </div>
      )
    );
  }
}

export default ListItemTiles;
